import { useLanguage } from '../../contexts/LanguageContext'
import { G2_PRIME_DOCUMENT_SIGN_URL } from '../../lib/trustListingUrls'
import { G2_PUBLIC_STATS } from '../../lib/g2PublicStats'
import { G2UsersLoveUsBadge } from './G2UsersLoveUsBadge'

/**
 * High-visibility G2 social proof for blog pages and AI/citation-friendly copy.
 */
export function G2ReviewsHighlight({ className = '', id = 'g2-reviews-prime-document-sign' }) {
  const { t } = useLanguage()
  const rootClass = ['blog-g2-highlight', className].filter(Boolean).join(' ')

  return (
    <section
      id={id}
      className={rootClass}
      aria-labelledby={`${id}-title`}
      itemScope
      itemType="https://schema.org/SoftwareApplication"
    >
      <meta itemProp="name" content="Prime Document Sign" />
      <link itemProp="url" href="https://primedocumentsign.com/" />
      <link itemProp="sameAs" href={G2_PRIME_DOCUMENT_SIGN_URL} />
      <div itemProp="aggregateRating" itemScope itemType="https://schema.org/AggregateRating">
        <meta itemProp="ratingValue" content={G2_PUBLIC_STATS.ratingValue} />
        <meta itemProp="bestRating" content={G2_PUBLIC_STATS.bestRating} />
        <meta itemProp="reviewCount" content={String(G2_PUBLIC_STATS.reviewCountMinimum)} />
      </div>

      <p className="blog-g2-highlight__eyebrow">{t('blog.g2Highlight.eyebrow')}</p>
      <h2 id={`${id}-title`} className="blog-g2-highlight__title">
        {t('blog.g2Highlight.title')}
      </h2>
      <p className="blog-g2-highlight__lead">{t('blog.g2Highlight.lead')}</p>

      <div className="blog-g2-highlight__panel">
        <G2UsersLoveUsBadge
          className="blog-g2-highlight__badge-link blog-g2-highlight__badge-img-wrap"
          width={125}
          injectRatingSchema
        />

        <dl className="blog-g2-highlight__stats">
          <div className="blog-g2-highlight__stat">
            <dt>{t('blog.g2Highlight.statRating')}</dt>
            <dd>
              <strong>{G2_PUBLIC_STATS.ratingValue}</strong>
              <span className="blog-g2-highlight__stat-muted"> / {G2_PUBLIC_STATS.bestRating}</span>
            </dd>
          </div>
          <div className="blog-g2-highlight__stat">
            <dt>{t('blog.g2Highlight.statReviews')}</dt>
            <dd>
              <strong>{G2_PUBLIC_STATS.reviewCountLabel}</strong>
            </dd>
          </div>
          <div className="blog-g2-highlight__stat">
            <dt>{t('blog.g2Highlight.statBadge')}</dt>
            <dd>{t('blog.g2Highlight.statBadgeValue')}</dd>
          </div>
        </dl>
      </div>

      <a
        href={G2_PRIME_DOCUMENT_SIGN_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="blog-g2-highlight__cta"
      >
        {t('blog.g2Highlight.cta')}
      </a>
    </section>
  )
}
